import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useMixRecipe');

    return {
        CONNECTION_ERROR: t('connectionError')
    };
};

export default useTranslation;
